import axios from "axios";
import jwt_decode from "jwt-decode";
import {
  ADD_SEARCH_USER_API,
  COMPARE_API,
  COMPARE_TWIN_API,
  CREATE_SNAPSHOT_API,
  DASHBOARD_BLOB_SIZE_API,
  DASHBOARD_DOWNLOAD_RECORDS_API,
  DASHBOARD_FILE_RENAME_API,
  DASHBOARD_FOLDER_RENAME_API,
  DASHBOARD_UPLOAD_VALIDATION_API,
  DELETE_USER_API,
  GET_ASSIGNEDROLES_API,
  GET_DATA_API,
  GET_PERMISSION_API,
  GET_ROLES_API,
  GET_TABLE_DATA_API,
  GET_WMKS_API,
  GET_XTOKEN,
  ISO_LIST_API,
  REBOOT_API,
  RESET_API,
  RESTORE_SNAPSHOT_API,
  SHUT_DOWN_API,
  START_API,
  STOP_API,
  TABLE_DATA_DELETE_API,
  UNMOUNT_ISO_API,
  UPDATE_USER_API,
  UPLOAD_CHUNK_API,
  UPLOAD_FILE_API,
  MOUNT_ISO_API,
  GET_SNAP_LIST_API,
  SEARCH_API,
  DELETE_SNAPSHOT_API,
  SUBMIT_FEEDBACK_API,
  DM_FILE_DOWNLOAD_API,
} from "../../common/apiEndPoint/apiEndPoint";
import AuthProvider from "../../common/authentication/authService";
import { store } from "../../store";

// Add a request interceptor
/* istanbul ignore next */
axios.interceptors.request.use(
  async (config) => {
    config.headers = config.headers ?? {};

    if (config.url !== undefined) {
      let str = config.url;
      if (str.search("forge") < 0) {
        const auth = AuthProvider();
        const token = auth.getAccessToken();
        const xToken = auth.getCookie("XSRF-TOKEN");
        if (token && xToken) {
          config.headers["Authorization"] = "Bearer " + token;
          config.headers["X-XSRF-TOKEN"] = xToken;
        }
      }
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  },
);
/* istanbul ignore next */
axios.interceptors.response.use(
  (response) => response,
  async (err) => {
    const status = err.response?.status;
    const xToken = await AuthProvider().getCookie("XSRF-TOKEN");

    // Handle refresh token expiration
    if (status === 400 && err.response?.data?.error === "invalid_grant") {
      localStorage.clear();
      AuthProvider().requestAuthCode();
      return Promise.reject(err);
    }

    if (
      status === 400 &&
      err.response?.statusText == "Bad Request" &&
      (xToken == "" || xToken == undefined)
    ) {
      const token = await AuthProvider().getAccessToken();
      await axios.get(`${GET_XTOKEN}`, {
        headers: {
          Authorization: "Bearer " + token, // the token is a variable which holds the token
        },
      });
      return axios(err.response.config);
    } else if (
      status === 401 &&
      // (err.response?.statusText?.toLowerCase() === "unauthorized" ||
      err.response?.data?.result?.toLowerCase() !== "unauthorized to access vcd"
    ) {
      if (AuthProvider().isAuthenticated() === false) {
        try {
          await AuthProvider().getRefreshToken();
          return axios(err.response.config);
        } catch (refreshError: any) {
          if (refreshError?.response?.data?.error === "invalid_grant") {
            localStorage.clear();
            AuthProvider().requestAuthCode();
          }
          return Promise.reject(refreshError);
        }
      }
      return axios(err.response.config);
    }

    return Promise.reject(err);
  },
);

export const cookieVal = () => {
  const cookie = AuthProvider()?.getCookie("XSRF-TOKEN");
  // const cookie = localStorage['XSRF-TOKEN'];
  if (cookie !== "") {
    return cookie;
  }
};
export const getCSRFAPI = async (requestParams: any) => {
  try {
    const res: any = await axios.get(`${GET_XTOKEN}`, {
      headers: {
        Authorization: `Bearer ${requestParams?.authorization}`, // the token is a variable which holds the token
      },
    });
    localStorage.setItem("XSRF-TOKEN", res.headers.get("xsrf-token"));
    return res;
  } catch (error) {}
};
export const getVMDetailsAPI = async (requestParams: any) => {
  try {
    const res: any = await axios.get(GET_DATA_API, {
      headers: {
        Accept: "application/json;version=36.3",
        Authorization: `Bearer ${requestParams?.authorization}`, // the token is a variable which holds the token
        siteId: requestParams?.orgs,
        tenantId: store.getState().reducer.selectedTenant,
        vmId: requestParams?.vmId ? requestParams.vmId : null,
        "X-XSRF-TOKEN": cookieVal(),
      },
    });
    if (res.status === 200 && res.data.length === 0) {
      res.data.push({
        siteId: requestParams?.orgs,
        id: requestParams?.orgs,
        name: requestParams?.orgs,
        displayName: requestParams?.orgs,
        description: requestParams?.orgs,
        vmDetails: [],
      });
    }
    return res;
  } catch (error) {}
};

export const getWMKSDataAPI = async (requestParams: any) => {
  try {
    const res: any = await axios.post(
      `${GET_WMKS_API}?VMId=${requestParams?.id ?? ""}`,
      "",
      {
        headers: {
          orgId: requestParams?.orgId ?? "",
          Authorization: `Bearer ${requestParams?.accessToken ?? ""}`,
          siteId: requestParams?.siteId ?? "",
          orgName: requestParams?.orgName ?? "",
          "X-XSRF-TOKEN": cookieVal(),
          tenantId: requestParams?.tenantId ?? "",
        },
      },
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const getPermissionAPI = async (requestParams: any) => {
  try {
    const res: any = await axios.get(
      `${GET_PERMISSION_API}`, // change the url for permission
      {
        headers: {
          User: requestParams?.userSub || "",
          Authorization: `Bearer ${requestParams?.authorization}`,
          "X-XSRF-TOKEN": cookieVal(),
        },
      },
    );

    if (
      res.status === 200 &&
      requestParams?.userSub === res.data.userDetails.userId
    ) {
      // Normalize resourceName and collect tenantIds in one pass
      const userPermissions = (res.data.userPermissions as any[]).map(
        (perm) => ({
          ...perm,
          resourceDetails: perm.resourceDetails.map((detail: any) => ({
            ...detail,
            resourceName: detail.resourceName ?? detail.resources,
          })),
        }),
      );

      res.data.tenantIds = userPermissions.map((item) => item.tenantId);
      res.data.userPermissions = userPermissions;
    } else if (requestParams?.userSub !== res.data.userDetails.userId) {
      throw new Error("User session mismatch");
    }
    return res;
  } catch (error) {
    console.log("error in response", error);
  }
};
export const getShutDownAPI = async (requestParams: any) => {
  try {
    const vmIds: any = requestParams?.vmId?.toString() || "";
    const res: any = await axios.post(
      `${SHUT_DOWN_API}`,
      "", // change the url for permission
      {
        headers: {
          vmID: vmIds,
          Authorization: `Bearer ${requestParams?.authorization}`,
          siteId: requestParams?.siteId,
          tenantId: store.getState().reducer.selectedTenant,
          "X-XSRF-TOKEN": cookieVal(),
          // 'orgId': requestParams?.orgId
        },
      },
    );
    return res;
  } catch (error) {}
};
export const getRebootAPI = async (requestParams: any) => {
  try {
    const vmIds: any = requestParams?.vmId?.toString() || "";
    const res: any = await axios.post(
      `${REBOOT_API}`,
      "", // change the url for permission
      {
        headers: {
          vmID: vmIds,
          Authorization: `Bearer ${requestParams?.authorization}`,
          siteId: requestParams?.siteId,
          tenantId: store.getState().reducer.selectedTenant,
          "X-XSRF-TOKEN": cookieVal(),
          // 'orgId': requestParams?.orgId
        },
      },
    );
    return res;
  } catch (error) {}
};
export const getStartAPI = async (requestParams: any) => {
  try {
    const vmIds: any = requestParams?.vmId?.toString() || "";
    const res: any = await axios.post(
      `${START_API}`,
      "", // change the url for permission
      {
        headers: {
          vmID: vmIds,
          Authorization: `Bearer ${requestParams?.authorization}`,
          siteId: requestParams?.siteId,
          tenantId: store.getState().reducer.selectedTenant,
          "X-XSRF-TOKEN": cookieVal(),
          // 'orgId': requestParams?.orgId
        },
      },
    );
    return res;
  } catch (error) {}
};
export const getResetAPI = async (requestParams: any) => {
  try {
    const vmIds: any = requestParams?.vmId?.toString() || "";
    const res: any = await axios.post(
      `${RESET_API}`,
      "", // change the url for permission
      {
        headers: {
          vmID: vmIds,
          Authorization: `Bearer ${requestParams?.authorization}`,
          siteId: requestParams?.siteId,
          tenantId: store.getState().reducer.selectedTenant,
          "X-XSRF-TOKEN": cookieVal(),
        },
      },
    );
    return res;
  } catch (error) {}
};

export const getPowerOffAPI = async (requestParams: any) => {
  try {
    const vmIds: any = requestParams?.vmId?.toString() || "";
    const res: any = await axios.post(
      `${STOP_API}`,
      "", // change the url for permission
      {
        headers: {
          vmID: vmIds,
          Authorization: `Bearer ${requestParams?.authorization}`,
          siteId: requestParams?.siteId,
          tenantId: store.getState().reducer.selectedTenant,
          "X-XSRF-TOKEN": cookieVal(),
        },
      },
    );
    return res;
  } catch (error) {}
};

export const getPowerOnAPI = async (requestParams: any) => {
  try {
    const vmIds: any = requestParams?.vmId?.toString() || "";
    const res: any = await axios.post(
      `${START_API}`,
      "", // change the url for permission
      {
        headers: {
          vmID: vmIds,
          Authorization: `Bearer ${requestParams?.authorization}`,
          siteId: requestParams?.siteId,
          tenantId: store.getState().reducer.selectedTenant,
          "X-XSRF-TOKEN": cookieVal(),
        },
      },
    );
    return res;
  } catch (error) {}
};

export const getCreateSnapshotAPI = async (requestParams: any) => {
  try {
    const vmIds: any = requestParams?.vmId?.toString() || "";
    const res: any = await axios.post(
      `${CREATE_SNAPSHOT_API}?snapshotName=${requestParams?.snapshotName}`,
      "", // change the url for permission
      {
        headers: {
          vmID: vmIds,
          Authorization: `Bearer ${requestParams?.authorization}`,
          siteId: requestParams?.siteId,
          tenantId: store.getState().reducer.selectedTenant,
          "X-XSRF-TOKEN": cookieVal(),
          // 'orgId': requestParams?.orgId
        },
      },
    );
    return res;
  } catch (error) {}
};
export const getRestoreSnapShotAPI = async (requestParams: any) => {
  try {
    const vmIds: any = requestParams?.vmId?.toString() || "";
    const res: any = await axios.post(
      `${RESTORE_SNAPSHOT_API}?snapshotId=${requestParams?.snapshotId}`,
      "", // change the url for permission
      {
        headers: {
          vmID: vmIds,
          Authorization: `Bearer ${requestParams?.authorization}`,
          siteId: requestParams?.siteId,
          tenantId: store.getState().reducer.selectedTenant,
          "X-XSRF-TOKEN": cookieVal(),
          // 'orgId': requestParams?.orgId
        },
      },
    );
    return res;
  } catch (error) {}
};
export const getDeleteSnapShotAPI = async (requestParams: any) => {
  try {
    const vmIds: any = requestParams?.vmId?.toString() || "";
    const res: any = await axios.delete(
      `${DELETE_SNAPSHOT_API}?snapshotId=${requestParams?.snapshotId}`, // change the url for permission
      {
        headers: {
          vmID: vmIds,
          Authorization: `Bearer ${requestParams?.authorization}`,
          siteId: requestParams?.siteId,
          tenantId: store.getState().reducer.selectedTenant,
          "X-XSRF-TOKEN": cookieVal(),
          // 'orgId': requestParams?.orgId
        },
      },
    );
    return res;
  } catch (error) {}
};
export const getUserRolesAPI = async (requestParams: any) => {
  try {
    const res: any = await axios.get(
      `${GET_ROLES_API}`, // change the url for permission
      {
        headers: {
          Authorization: `Bearer ${requestParams?.authorization}`,
          siteId: requestParams?.siteId,
          "X-XSRF-TOKEN": cookieVal(),
          tenantId: requestParams?.tenantId, // Added tenantId to headers
        },
      },
    );
    return res;
  } catch (error) {}
};
export const getAssignedRolesAPI = async (requestParams: any) => {
  try {
    const res: any = await axios.get(
      `${GET_ASSIGNEDROLES_API}`, // change the url for permission
      {
        headers: {
          Authorization: `Bearer ${requestParams?.authorization}`,
          siteId: requestParams?.siteId,
          "X-XSRF-TOKEN": cookieVal(),
          tenantId: requestParams?.tenantId, // Added tenantId to headers
        },
      },
    );
    return res;
  } catch (error) {}
};
export const getUserDeleteAPI = async (requestParams: any) => {
  try {
    const res: any = await axios.delete(
      `${DELETE_USER_API}`, // change the url for permission
      {
        data: requestParams?.deleteUsers,
        headers: {
          Authorization: `Bearer ${requestParams?.authorization}`,
          siteId: requestParams?.siteId,
          userId: requestParams?.userId,
          "X-XSRF-TOKEN": cookieVal(),
          tenantId: requestParams?.tenantId, // Added tenantId to headers
        },
      },
    );
    return res;
  } catch (error) {}
};
export const getNewUserAPI = async (requestParams: any) => {
  const res: any = await axios.post(
    `${ADD_SEARCH_USER_API}`,
    requestParams?.data, // change the url for permission
    {
      headers: {
        Authorization: `Bearer ${requestParams?.authorization}`,
        siteId: requestParams?.siteId,
        "X-XSRF-TOKEN": cookieVal(),
        tenantId: requestParams?.tenantId, // Added tenantId to headers
      },
    },
  );
  return res;
};
export const getUpdateRoleUserAPI = async (requestParams: any) => {
  try {
    const res: any = await axios.put(
      `${UPDATE_USER_API}`,
      requestParams?.data, // change the url for permission
      {
        headers: {
          Authorization: `Bearer ${requestParams?.authorization}`,
          siteId: requestParams?.siteId,
          userId: requestParams?.userId,
          "X-XSRF-TOKEN": cookieVal(),
          tenantId: requestParams?.tenantId, // Added tenantId to headers
        },
      },
    );
    return res;
  } catch (error) {}
};
// export const getCompareDataAPI = async (requestParams: any) => {
//   try {
//     const res = await axios.get(`${COMPARE_API}`, {
//       headers: {
//         Accept: "application/json;version=36.3",
//         Authorization: `Bearer ${localStorage.getItem("access_token")}`,
//         siteId: requestParams?.siteId,
//         twinId: requestParams?.twinId,
//         "X-XSRF-TOKEN": cookieVal(),
//       },
//     });
//     return res;
//   } catch (error) {}
// };
// data
export const gettabledataAPI = async (requestParams: any) => {
  try {
    // const res=await axios.get(`${GET_TABLE_DATA_API}?container=${requestParams.container}`,
    // //&page=${requestParams?.page}&pageSize=${requestParams?.pageSize}
    const res = await axios.get(
      `${GET_TABLE_DATA_API}?parentPath=${requestParams?.parentPath}`,
      {
        headers: {
          Accept: "application/json;version=36.3",
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          siteId: requestParams?.siteId,
          "X-XSRF-TOKEN": cookieVal(),
        },
      },
    );
    return res;
  } catch (error) {}
};
export const getUploadAPI = async (requestParams: any) => {
  if (requestParams != null && requestParams != undefined) {
    try {
      const res = await axios.post(
        `${UPLOAD_FILE_API}`,
        requestParams?.data, // change the url for permission
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            siteId: requestParams?.siteid,
            "X-XSRF-TOKEN": cookieVal(),
          },
        },
      );

      return res.data;
    } catch (error) {}
  }
};

//New
// export const getDeleteTableDataAPI = async (requestParams: any) => {
//   try {
//     const res = await axios.post(`${TABLE_DATA_DELETE_API}`, requestParams.param,
//       {
//         headers: {
//           'Authorization': `Bearer ${requestParams.authorization}`,
//           'siteId': requestParams?.siteid,
//           'X-XSRF-TOKEN': cookieVal()
//         }
//       });
//     return res;
//   } catch (error) {
//
//   }
// }
export const getDeleteTableDataAPI = async (requestParams: any) => {
  if (requestParams != null && requestParams != undefined) {
    try {
      const res = await axios.delete(`${TABLE_DATA_DELETE_API}`, {
        headers: {
          Authorization: `Bearer ${requestParams.authorization}`,
          siteId: requestParams?.siteid,
          "X-XSRF-TOKEN": cookieVal(),
        },
        data: requestParams.param,
      });
      return res;
    } catch (error) {}
  }
};

export const fileRenameDashboardApi = async (requestParams: any) => {
  if (requestParams != null && requestParams != undefined) {
    try {
      if (requestParams != null && requestParams != undefined) {
        const res = await axios.post(
          `${DASHBOARD_FILE_RENAME_API}`,
          requestParams.param, // change the url for permission
          {
            headers: {
              Authorization: `Bearer ${requestParams.authorization}`,
              siteId: requestParams?.siteid,
              "X-XSRF-TOKEN": cookieVal(),
            },
          },
        );
        return res;
      }
      // return
    } catch (error) {}
  }
};
export const folderRenameDashboardApi = async (requestParams: any) => {
  if (requestParams != null && requestParams != undefined) {
    try {
      const res = await axios.post(
        `${DASHBOARD_FOLDER_RENAME_API}`,
        requestParams.param, // change the url for permission
        {
          headers: {
            Authorization: `Bearer ${requestParams.authorization}`,
            siteId: requestParams?.siteid,
            "X-XSRF-TOKEN": cookieVal(),
          },
        },
      );
      return res;
      // return
    } catch (error) {}
  }
};
export const getDashboardBlobDataApi = async (requestParams: any) => {
  if (requestParams != null && requestParams != undefined) {
    try {
      const res = await axios.get(
        `${DASHBOARD_BLOB_SIZE_API}?container=${requestParams?.container}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            siteId: requestParams?.container,
            "X-XSRF-TOKEN": cookieVal(),
          },
        },
      );

      return res;
    } catch (error) {}
  }
};
//Upload Validation Api
export const dashboardUploadValidation = async (requestParams: any) => {
  if (requestParams != null && requestParams != undefined) {
    try {
      const res = await axios.get(
        `${DASHBOARD_UPLOAD_VALIDATION_API}?filename=${requestParams.params.filename}&parentPath=${requestParams.params.parentPath}`,
        {
          headers: {
            Authorization: `Bearer ${requestParams.authorization}`,
            siteId: requestParams?.siteid,
            "X-XSRF-TOKEN": cookieVal(),
          },
        },
      );

      return res;
    } catch (error) {}
  }
};

export const uploadChunk = async (requestParams: any) => {
  try {
    const res = await axios.post(`${UPLOAD_CHUNK_API}`, requestParams.param, {
      headers: {
        Authorization: `Bearer ${requestParams.authorization}`,
        siteId: requestParams.siteid,
        "X-XSRF-TOKEN": cookieVal(),
      },
    });

    return res;
  } catch (error) {}
};

export const getISOListApi = async (requestParams: any) => {
  try {
    const res: any = await axios.get(`${ISO_LIST_API}`, {
      headers: {
        Authorization: `Bearer ${requestParams?.accessToken}`,
        siteId: requestParams?.siteId,
        tenantId: requestParams?.tenantId,
        "X-XSRF-TOKEN": cookieVal(),
      },
    });
    return res;
  } catch (error) {}
};

export const mountISO = async (requestParams: any) => {
  try {
    const res: any = await axios.post(
      `${MOUNT_ISO_API}`,
      requestParams?.isoData,
      {
        headers: {
          Authorization: `Bearer ${requestParams?.authorization}`,
          siteId: requestParams?.siteId,
          orgId: requestParams?.orgId,
          vmId: requestParams?.vmId,
          tenantId: store.getState().reducer.selectedTenant,
          "X-XSRF-TOKEN": cookieVal(),
        },
      },
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const unMountISO = async (requestParams: any) => {
  try {
    const res: any = await axios.post(`${UNMOUNT_ISO_API}`, "", {
      headers: {
        Authorization: `Bearer ${requestParams?.authorization}`,
        siteId: requestParams?.siteId,
        tenantId: store.getState().reducer.selectedTenant,
        orgId: requestParams?.orgId,
        vmId: requestParams?.vmId,
        "X-XSRF-TOKEN": cookieVal(),
      },
    });
    return res;
  } catch (error) {}
};

export const getListSnapShotAPI = async (requestParams: any) => {
  try {
    const res: any = await axios.get(
      `${GET_SNAP_LIST_API}?vmId=${requestParams?.vmId}`,
      {
        headers: {
          Authorization: `Bearer ${requestParams?.accessToken}`,
          siteId: requestParams?.siteId,
          tenantId: store.getState().reducer.selectedTenant,
          "X-XSRF-TOKEN": cookieVal(),
        },
      },
    );
    return res;
  } catch (error) {}
};
export const getSearchListAPI = async (requestParams: any) => {
  try {
    const res: any = await axios.get(
      `${SEARCH_API}?searchFileName=${requestParams?.searchFileName}`,
      {
        headers: {
          Accept: "application/json;version=36.3",
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          siteId: requestParams?.siteId,
          "X-XSRF-TOKEN": cookieVal(),
        },
      },
    );
    return res;
  } catch (error) {}
};
export const getFeedbackAPI = async (requestParams: any) => {
  try {
    const res: any = await axios.post(
      `${SUBMIT_FEEDBACK_API}`,
      requestParams?.feedbackData,
      {
        headers: {
          Accept: "application/json;version=36.3",
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          siteId: requestParams?.siteId,
          emailId: requestParams?.emailId,
          "X-XSRF-TOKEN": cookieVal(),
        },
      },
    );
    return res;
  } catch (error) {}
};
export const getDMFileDownloadAPI = async (requestParams: any) => {
  try {
    const res: any = await axios.post(
      `${DM_FILE_DOWNLOAD_API}`,
      requestParams?.downloadData, // change the url for permission
      {
        headers: {
          Accept: "application/json;version=36.3",
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          siteId: requestParams?.siteId,
          "X-XSRF-TOKEN": cookieVal(),
        },
      },
    );
    return res;
  } catch (error) {
    return error;
  }
};
// export const getCompareAPI = async (requestParams: any) => {
//   try {
//     // const res: any = await axios.post(`${GET_WMKS_API}?VMId=${requestParams?.id}`,'',
//     const res: any = await axios.post(
//       `${COMPARE_TWIN_API}`,
//       {}, // change the url for permission
//       {
//         headers: {
//           Authorization: `Bearer ${requestParams?.authorization}`,
//           siteId: requestParams?.siteId,
//           "X-XSRF-TOKEN": cookieVal(),
//         },
//       }
//     );
//     return res;
//   } catch (error) {}
// };
